import { useContext } from 'react'
import { CashflowEventsContext } from '../context'
import { FORM_STATES } from '../reducer'

export const getFormEventTypeFromState = () => {
  const { state } = useContext(CashflowEventsContext)
  const { formState, eventType, eventAttributes } = state
  const formEventType = formState === FORM_STATES.EDIT
    ? eventAttributes.event_type
    : eventType
  return formEventType
}
